import styled from '@emotion/styled'
import { PharmacIcon } from '@pharmac/ui'
import { ExtranetTableColumn } from './ExtranetTableColumn'

export const ExtranetCatalogItemChevron = ({ isExpanded }: { isExpanded?: boolean }) => {
  return (
    <PharmacIcon
      icon="chevronDown"
      style={{
        color: 'var(--color-primary)',
        marginTop: 'var(--spacing-small)',
        transition: 'var(--transition-cubic-bezier)',
        transform: `rotate(${!!isExpanded ? '180' : '0'}deg)`,
      }}
    />
  )
}

export const ExtranetExpandSelectChevron = ({ isExpanded }: { isExpanded?: boolean }) => {
  return (
    <PharmacIcon
      icon="chevronDown"
      size="18px"
      style={{
        marginRight: 'var(--spacing-medium)',
        color: 'var(--color-black)',
        marginTop: 'var(--spacing-small)',
        transition: 'var(--transition-cubic-bezier)',
        transform: `rotate(${!!isExpanded ? '180' : '0'}deg)`,
      }}
    />
  )
}

export const ExtranetExpandArrowColumn = styled(ExtranetTableColumn)`
  min-width: 50px;
  max-width: 50px;
  margin-left: auto;
`
